import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Comparativas" },
  { label: "Ventas Mensual Comp.",  icon: "fas fa-chart-line",    color: "#10b981", bg: "#f0fdf4", href: "/GraficaVentasMensualComparativa", desc: "Comparativa mensual de ventas",  perm: "menu_reportes" },
  { label: "Ventas x Estado",       icon: "fas fa-map-marker-alt",color: "#ef4444", bg: "#fef2f2", href: "/GraficaVentasEstado",             desc: "Ventas por estado",              perm: "menu_reportes" },

  { type: "section", label: "Por Dimensión" },
  { label: "Ventas Mensual Vend.",  icon: "fas fa-calendar-alt",  color: "#6366f1", bg: "#eef2ff", href: "/GraficaVentasMensualVendedor",    desc: "Mensual por vendedor",           perm: "menu_reportes" },

  { type: "section", label: "Inventario y Rentabilidad" },
  { label: "Valor Inventario",      icon: "fas fa-dollar-sign",   color: "#10b981", bg: "#f0fdf4", href: "/ValorInventario",                 desc: "Valor monetario del inventario", perm: "menu_reportes" },
  { label: "Sell Thru",             icon: "fas fa-percent",       color: "#f97316", bg: "#fff7ed", href: "/SellThru",                        desc: "Indicador de agotamiento",       perm: "menu_reportes" },
  { label: "Sell Thru Área",        icon: "fas fa-warehouse",     color: "#f97316", bg: "#fff7ed", href: "/SellThruArea",                    desc: "Sell thru por área/almacén",     perm: "menu_reportes" },

  { type: "section", label: "Desglose y Dashboard" },
  { label: "Ventas Desgloce",       icon: "fas fa-table",         color: "#64748b", bg: "#f8fafc", href: "/GraficaVentasDesgloce",           desc: "Desglose detallado de ventas",   perm: "menu_reportes" },
  { label: "Dashboard Ventas",      icon: "fas fa-tachometer-alt",color: "#8b5cf6", bg: "#f5f3ff", href: "/DashboardVentasTabla",            desc: "Tabla de dashboard ventas",      perm: "menu_reportes" },
];

function BotonesReportesVentas() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-chart-line" color="#10b981" bg="#f0fdf4" title="Reportes de Ventas" subtitle="Análisis y gráficas de ventas" />
        {user.menu_reportes ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesReportesVentas;
